import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import CountryFlag from "vue-country-flag";
import vuetify from './plugins/vuetify';
import moment from "moment";

Vue.config.productionTip = false;

Vue.use(require('vue-moment'), {
  moment
})

new Vue({
  router,
  vuetify,
  i18n,
  CountryFlag,
  store,
  render: h => h(App)
}).$mount("#app");
